var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-grid"},_vm._l((_vm.items),function(item,index){return _c('div',{key:`image-grid_item_${index}`,staticClass:"image-grid__item",class:`width-${item.width}`},[_c('div',{staticClass:"image-grid__item__label"},[_vm._v(" "+_vm._s(_vm.localize(item.label))+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }